import React, { useState, useEffect } from "react";
import { Search } from "lucide-react";
import Papa from "papaparse";
import FilterDropdown from "../commonDropDown/FilterDropdown";
import { aiSkills, aiCareerTitles, aiTools } from "../../constants/constants";
import { COLORS } from "../../constants/colors";

const SearchSection = ({ activeFilters, onFilterChange, onClearFilters }) => {
  const [occupations, setOccupations] = useState([]);

  useEffect(() => {
    const loadCSV = async () => {
      try {
        const response = await fetch("/output.csv");
        const csvText = await response.text();

        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: ({ data }) => {
            const options = data
              .filter(row => row.name?.trim())
              .map(row => ({ value: row.name, label: row.name }));
            setOccupations(options);
          }
        });
      } catch (err) {
        console.error("Error fetching CSV:", err);
      }
    };

    loadCSV();
  }, []);

  const filterData = [
    { key: "occupation", label: "Mainstream Occupation", options: occupations, placeholder: "Select occupation" },
    { key: "aiCareer", label: "AI Emerging Career", options: aiCareerTitles, placeholder: "Select AI career" },
    { key: "aiSkill", label: "AI Skill", options: aiSkills, placeholder: "Select AI skill" },
    { key: "aiTool", label: "AI Tool", options: aiTools, placeholder: "Select AI tool" }
  ];

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm">
      {/* Header */}
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: COLORS.purple }}>
          <Search className="w-5 h-5 text-white" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Search for a Mentor</h2>
          <p className="text-gray-600">Find mentors by occupation, career, skills, or tools.</p>
        </div>
      </div>

      {/* Filters */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        {filterData.map(({ key, label, options, placeholder }) => (
          <FilterDropdown
            key={key}
            label={label}
            options={options}
            value={activeFilters[key] || ""}
            onChange={(val) => onFilterChange(key, val)}
            placeholder={placeholder}
            search
          />
        ))}
      </div>

      {/* Buttons */}
      <div className="flex gap-3">
        <button
          className="flex-1 flex items-center justify-center gap-2 px-3 py-2 text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity"
          style={{ backgroundColor: COLORS.purple }}
        >
          <Search className="w-4 h-4" />
          Search Mentors
        </button>
        <button
          onClick={onClearFilters}
          className="px-4 py-2 border border-purple-300 text-purple-600 text-sm font-medium rounded-lg hover:bg-purple-50 transition-colors"
        >
          Clear Filters
        </button>
      </div>
    </div>
  );
};

export default SearchSection;
